import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faCompress,
  faExpand,
  faMinus,
  faPlus,
  faTimes,
} from '@fortawesome/pro-solid-svg-icons';

import { InstitutionsService } from '../../services';

@Component({
  selector: 'app-stack',
  imports: [FaIconComponent],
  templateUrl: './stack.component.html',
  styleUrls: ['./stack.component.scss'],
})
export class StackComponent {
  router = inject(Router);
  institutionsService = inject(InstitutionsService);

  showIcons: boolean;
  showText: boolean;
  collapseModals: boolean;
  showWorkCount: boolean;

  @Input() expandable = true;
  @Input() expandOnlyEmits = false;
  @Input() title = '';
  @Input() count: number = null;
  @Input() buttonText: string = null;

  @Input() set scrollable(scrollable: boolean) {
    this._scrollable = scrollable;
    this._originalScrollableSetting = scrollable;
  }

  @Output() expand = new EventEmitter();
  @Output() buttonClick = new EventEmitter();
  expanded = false;
  _originalScrollableSetting = true;
  _scrollable = true;
  faCompress = faCompress;
  faExpand = faExpand;
  faTimes = faTimes;
  faPlus = faPlus;
  faMinus = faMinus;

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._scrollable = this._originalScrollableSetting;
        this.expanded = false;
      }
    });
    this.institutionsService.context.subscribe((context) => {
      this.showIcons = context.setExpandAndCollapseLanguageToPlusMinusIcons;
      this.showText = !context.setExpandAndCollapseLanguageToPlusMinusIcons;
      this.collapseModals = context.collapseScholarPagesAndResearchTopicsModals;
      this.showWorkCount = context.displayNumberOfWorksInEachModalHeader;
    });
  }

  requestExpansion() {
    if (!this.expandable) {
      return;
    }
    if (!this.expandOnlyEmits) {
      this._scrollable = !this._scrollable;
      this.expanded = !this.expanded;
    }
    this.expand.emit();
  }
}
